<div class="cutoff">
  <app-grid>
    @if (showHeader) {
      <app-cell
        laptop="1:5"
        mobile="1:12"
        >
        <div class="carousel-container row-1">
          <div class="head-text">
            <h3 class="subheading serif">
              {{ subtitle }}
            </h3>
            <h1>
              {{ title }}
            </h1>
          </div>
        </div>
      </app-cell>
    }

    <app-cell mobile="5:full"
                  [responsiveStyle$]="{
                base: {
                    display: 'block'
                },
                tablet: {
                    display: 'none'
                },
                mobile: {
                    display: 'none'
                }
          } | responsiveStyle$"
    >
    <div class="carousel-container row-1 enter">
      <div class="carousel-container row-1-background theme-{{theme | lowercase}}"></div>
    </div>
  </app-cell>

  <app-cell mobile="full:0"
                  [responsiveStyle$]="{
                base: {
                    display: 'block'
                },
                tablet: {
                    display: 'none'
                },
                mobile: {
                    display: 'none'
                }
          } | responsiveStyle$"
  >
  @if (showScrollBar) {
    <app-scroll-indicator
    ></app-scroll-indicator>
  }
</app-cell>

<app-cell laptop="0:6"
  mobile="full:full"
  >
  <div class="carousel-container">
    <div class="main-image">
      @for (card of slides; track card; let i = $index) {
        @if (i === swiper?.swiper?.realIndex && card.backgroundImage) {
          <app-responsive-image
            [image]="card.backgroundImage"
            @fade
            [lazyLoad]="lazyLoad"
          ></app-responsive-image>
        }
      }
    </div>
  </div>
</app-cell>

<app-cell mobile="full:0"
                  [responsiveStyle$]="{
                base: {
                    display: 'none'
                },
                tablet: {
                    display: 'block'
                },
                mobile: {
                    display: 'block'
                }
          } | responsiveStyle$"
>
<div class="carousel-container row-2 theme-{{theme | lowercase}}"></div>
</app-cell>

<app-cell laptop="6:full"
  mobile="0:full"
  >
  <div class="carousel-container row-2 theme-{{theme | lowercase}} center-end">
    <div class="swiper-container">
      <swiper [config]="swiperOptions"
        (swiper)="onSwiper($event)"
        (slideChange)="onSlideChange()"
        >
        @for (card of slides; track card) {
          <ng-template swiperSlide>
            <div class="card">
              <div class="card-inner">
                <div class="card-front">
                  @if (card.backgroundImage) {
                    <app-responsive-image
                      [image]="card.backgroundImage"
                      @fade
                      [lazyLoad]="lazyLoad"
                    ></app-responsive-image>
                  }
                  @if (card.mainImage) {
                    <div
                      class="right"
                      >
                      <app-responsive-image [image]="card.mainImage"
                        [lazyLoad]="lazyLoad"
                      ></app-responsive-image>
                    </div>
                  }
                </div>
                <div class="card-back">
                  <div class="left">
                    <h3 class="subheading--soft">
                      {{ card.subtitle }}
                    </h3>
                    <h2 class="serif">
                      {{ card.title }}
                    </h2>
                    @if (card.text) {
                      <label
                        class="small"
                        [innerHTML]="card.text | truncateText: 250 | safe: 'html'"
                      ></label>
                    }
                    @if (card.link) {
                      <div
                        class="link"
                        >
                        <app-chevron-link
                          size="normal"
                          iconColor="dark"
                          [link]="card.link.link"
                          [target]="card.link.target"
                          >  {{ card.link.label }}
                        </app-chevron-link>
                      </div>
                    }
                  </div>
                  @if (card.mainImage) {
                    <div
                      class="right"
                      >
                      <app-responsive-image [image]="card.mainImage"
                        [lazyLoad]="lazyLoad"
                      ></app-responsive-image>
                    </div>
                  }
                </div>
              </div>
            </div>
          </ng-template>
        }
      </swiper>
    </div>

    <div class="pagination-container theme-{{theme.toLowerCase()}}">
      @if (swiper && swiper.totalIndex && swiper.totalIndex > 1) {
        <p class="index"
          >
          {{ swiper.swiperIndex }}/{{ swiper.totalIndex }}
        </p>
      }

      <div #pagination></div>

      @if (swiper && swiper.totalIndex && swiper.totalIndex > 1) {
        <div
          class="arrow-container"
          >
          <span appIcon="arrow-left"
            class="navigation-icon"
            (click)="swiper.slidePrev()"
          ></span>
          <span appIcon="arrow-right"
            class="navigation-icon "
            (click)="swiper.slideNext()"
          ></span>
        </div>
      }
    </div>
  </div>
</app-cell>

<app-cell mobile="5:full"
                  [responsiveStyle$]="{
                base: {
                    display: 'block'
                },
                tablet: {
                    display: 'none'
                },
                mobile: {
                    display: 'none'
                }
          } | responsiveStyle$"
>
<div class="carousel-container row-1 theme-{{theme | lowercase}} cutoff bottom-right"></div>
</app-cell>
</app-grid>
</div>
